import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { confirmRemoveAddingUser, submitDeleteProjectUser } from '../handler/ProjectUserManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ConfirmDeleteUserProject({ openConfirmModal, argsAll }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const userId = openConfirmModal.userId;
    const userList = !Utils.isEmptyArray(argsAll?.userList) ? argsAll?.userList : [];
    const isDeleteProjectUser = Utils.findIndexInArrayById(userId, userList) !== -1 ? true : false;

    const handleCloseConfirmModal = () => {
        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    const handleDeleteUser = () => {
        if (isDeleteProjectUser) {
            submitDeleteProjectUser(argsAll, userId);
        } else {
            confirmRemoveAddingUser(argsAll, openConfirmModal.userId );
        }

        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    return (
        <Dialog
            open={openConfirmModal.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">
                    {isDeleteProjectUser ? trI18n('USER09MSG006') : trI18n('USER12MSG005')}
                </div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={() => handleDeleteUser()}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteUserProject;
